import { render, staticRenderFns } from "./CreatorShopLink.vue?vue&type=template&id=368eda6a"
import script from "./CreatorShopLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatorShopLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LtkShopAvatar: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkShopAvatar.vue').default})
